import { authRoles } from 'app/auth';
import Login from './Login';

const LoginConfig = {
    settings: {
        layout: {
            config: {
                navbar: { display: false },
                toolbar: { display: false },
                footer: { display: false },
                leftSidePanel: { display: false },
                rightSidePanel: { display: false },
            },
        },
    },
    auth: authRoles.onlyGuest,
    routes: [{ path: '/login', component: Login }],
};

export default [LoginConfig];
